
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.999","height":"15.999","viewBox":"0 0 15.999 15.999"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M2.092 0A2.1 2.1 0 11.615.615 2.074 2.074 0 012.092 0zm.644 1.448a.913.913 0 10.266.644.919.919 0 00-.267-.644zM2.092 11.815a2.1 2.1 0 11-1.477.615 2.072 2.072 0 011.477-.615zm.644 1.448a.912.912 0 10.266.644.919.919 0 00-.267-.644zM2.092 5.908a2.1 2.1 0 11-1.477.614 2.074 2.074 0 011.477-.614zm.644 1.448A.912.912 0 103.002 8a.916.916 0 00-.267-.644zM7.999 0a2.1 2.1 0 11-1.477.615A2.074 2.074 0 017.999 0zm.644 1.448a.913.913 0 10.266.644.92.92 0 00-.266-.644zM7.999 11.815a2.1 2.1 0 11-1.477.615 2.072 2.072 0 011.477-.615zm.644 1.448a.913.913 0 10.266.644.919.919 0 00-.266-.644zM7.999 5.908a2.1 2.1 0 11-1.477.614 2.074 2.074 0 011.477-.614zm.644 1.448A.913.913 0 108.909 8a.917.917 0 00-.266-.644zM13.906 0a2.1 2.1 0 11-1.477.615A2.075 2.075 0 0113.906 0zm.644 1.448a.912.912 0 10.266.644.92.92 0 00-.266-.644zM13.906 11.815a2.1 2.1 0 11-1.477.615 2.073 2.073 0 011.477-.615zm.644 1.448a.912.912 0 10.266.644.919.919 0 00-.266-.644zM13.906 5.908a2.1 2.1 0 11-1.477.614 2.075 2.075 0 011.477-.614zm.644 1.448a.912.912 0 10.266.644.917.917 0 00-.266-.644z"}})])
          )
        }
      }
    